import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-10 scrollable-section" }
const _hoisted_2 = { class: "pt-16 position-relative" }
const _hoisted_3 = { class: "buttons-container" }
const _hoisted_4 = { class: "d-flex align-center my-3 ga-2" }

import Icon from "@/components/Icons/Icon.vue";
import {useRoute, useRouter} from "vue-router";
import {computed, onMounted, ref} from "vue";
import CreatedBy from "@/components/custom/CreatedBy.vue";
import HealthGoalForm from "@/views/ClientComponents/HealthGoals/Components/HealthGoalForm.vue";
import {healthGoalsService} from "@/api/services/healthGoals";
import {useSettingsStore} from "@/api/store/settings";
import ButtonBase from "@/components/custom/ButtonBase.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'EditHealthGoals',
  setup(__props) {

const settingsStore = useSettingsStore();

const router = useRouter();
const route = useRoute();

const errors = ref(null);

const formState = ref({
  name: '',
  description: '',
  reason: '',
  timeframe_value: '',
  timeframe_unit: 'select',
  severity_rating: 0,
  status: null,
  is_complete: null
});

const disableSave = computed(() => {
  return !formState.value.name || !formState.value.description || !formState.value.reason || !formState.value.timeframe_value || !formState.value.timeframe_unit || !formState.value.severity_rating;
})

const isCompleted = computed(() => {
  return formState.value.is_complete === 'complete';
})

const isActive = computed(() => {
  return formState.value.status === 'active';
})

const onSave = () => {
  
  healthGoalsService.update(route.params.id, formState.value)
      .then(() => {
        
        router.push({name: 'health-goals'});
      })
      .catch((error) => {
        console.log(error);
        errors.value = error.response.data.errors
        
      });
}

const fetchHealthGoal = () => {
  healthGoalsService.show(route.params.id).then((response) => {
    formState.value = response.data;
  });
}

const onComplete = () => {
  formState.value.is_complete = isCompleted.value ? 'incomplete' : 'complete';

  if (formState.value.is_complete === 'complete') {
    formState.value.status = 'archived';
  }
}

const onArchive = () => {
  formState.value.status = isActive.value ? 'archived' : 'active';

  if (isActive.value) {
    formState.value.is_complete = null;
  }
}

onMounted(fetchHealthGoal)

return (_ctx: any,_cache: any) => {
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_container, { class: "px-0 pt-0 pb-5" }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "text-right px-4 pt-3",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'health-goals' })))
        }, [
          _createVNode(Icon, {
            color: "primaryColor",
            icon: "cross-icon"
          })
        ]),
        _createElementVNode("section", _hoisted_1, [
          _createVNode(CreatedBy),
          _createVNode(HealthGoalForm, {
            modelValue: formState.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formState).value = $event)),
            errors: errors.value
          }, null, 8, ["modelValue", "errors"])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(ButtonBase, {
            "custom-class": isCompleted.value ? 'secondary-button' : 'bg-white grey-btn text-black',
            text: isCompleted.value ? 'Completed' : 'Mark Completed',
            icon: isCompleted.value ? 'thick-icon' : '',
            "color-icon": "secondary-button-color",
            width: "48%",
            onClick: onComplete
          }, null, 8, ["custom-class", "text", "icon"]),
          _createVNode(ButtonBase, {
            "custom-class": "white-btn text-white font-size-12-600",
            text: isActive.value ? 'Archive' : 'Unarchive',
            icon: isActive.value ? 'archived-icon' : 'unarchived-icon',
            "color-icon": "primary-color",
            width: "48%",
            onClick: onArchive
          }, null, 8, ["text", "icon"])
        ]),
        _createVNode(ButtonBase, {
          "custom-class": ['text-white', {
          'primary-button': !disableSave.value,
          'grey-disable': disableSave.value || _unref(settingsStore).loading
        }],
          "custom-icon-class": "add-new-circle-icon",
          text: "Save",
          width: "100%",
          onClick: onSave
        }, null, 8, ["custom-class"])
      ])
    ])
  ], 64))
}
}

})